<template>
  <div class="register" v-loading="loading" element-loading-spinner="my-loading">
    <bHeader @getPaddingTop='getPaddingTop'></bHeader>
    <div v-if='!isCompleted' style="overflow:hidden" :style="{'padding-top': paddingTop}">
      <bStepTitle></bStepTitle>
      <bBar class="b-bar" :current.sync="current"></bBar>
      <bStepComponents :component="components" :AA_Number="AA_Number" ref="comp" :formData="formData" :Lead="Lead" :middle_dataware="middle_dataware" :params.sync="recodeModel" :screenWidth="screenWidth" class="step-component"></bStepComponents>
      <bButton :current.sync="current" :maxCurrent="maxCurrent" @submit="submit" @nextCurrent="nextCurrent" @backCurrent="backCurrent" :isDisable.sync="isDisable"></bButton>
    </div>
    <iframe :src='"../../static/uk-success.html?lang="+LANGUAGE+"&indexurl="+IndexUrl' width="100%" id="external-frame" style='height:46em !important' v-if="isCompleted"></iframe>
    <bFooter></bFooter>
    <a id="qqmsg" href="https://wpa.b.qq.com/cgi/wpa.php?ln=1&key=XzgwMDg1MDgyN180ODkxNzJfODAwODUwODI3XzJf" target="_blank" rel="nofollow noopener"></a>
  </div>
</template>
<script>
  import Vue from "vue";
  import { mapState } from "vuex";
  import PersonalDetail1 from "./steps/personal-detail-1";
  import PersonalDetail2 from "./steps/personal-detail-2";
  import FinancialDetails from "./steps/financialDetails";
  import Experience from "./steps/experience";
  import Knowledge from "./steps/knowledge";
  import Acknowledgements from "./steps/acknowledgements";
  import Preview from "./preview";
  import Cookies from 'js-cookie';

  import { GET_COUNTRY_CODE,IsDev,INDEXURL,IsMaintain, MU_APPLY_URL,GET_COUNTRY_CODE_PRD} from '@/api/env.js';
  import { URL_GETCOUNTRYCODE,URL_SAVEPERSONINFO,URL_REGISTER,URL_CHECKBLACKIBCODE,URL_IBCODE } from '@/api/api.js';
  import getCountryCodeByIP from '@/assets/js/getCountryCodeByIP.js';
  import { log } from 'util';
  const crypto = require('crypto')
  export default {
    name: "register",
    inject:['setIframeHeight'],
    props: ['screenWidth'],
    data() {
      return {
        loading:false,
        IndexUrl:INDEXURL,
        isCompleted:false,
        isFirstClick:false,
        componentsArr: [
          PersonalDetail1,
          PersonalDetail2,
          FinancialDetails,
          Experience,
          Knowledge,
          Acknowledgements,
          Preview
        ],
        current: 0,
        maxCurrent: 6,
        components: PersonalDetail1,
        formData: {
          // 第1页
          Title: null,
          OtherTitle: null,
          First_Name: null,
          Surname: null,
          Gender: null,
          Email: null,
          Email_Confirm: null,
          Lang: null,
          Country: null,
          Phone: null,
          curPhoneCode: null,
          Account_Type: null,
          MT4_Currency: null,
          // 第2页
          Addr: null,
          Addr2: null,
          Building_Name: null,
          Street: null,
          City: null,
          Province: null,
          Postcode: null,
          Birth_Date_Year: null,
          Birth_Date_Month: null,
          Birth_Date_Day: null,
          Birth_Date:null,
          Nationality: null,
          Doc_No: null,
          Bank: null,
          OtherBank: null,
          Bank_Card_No: null,
          Beneficiary_Name: null,
          Branch_Province: null,
          Branch_City: null,
          Branch_Name: null,
          Bank_Addr: null,
          SWIFT_Code: null,
          Dual_Nationality:null,
          Doc_Front_Img: [],
          Doc_Back_Img: [],
          Proof_of_Address: [],
          Proof_of_Address_2: [],
          Other_Files: [],
          IS_Politically_Person:null, //是否政府公众人物
          // 第3页
          Emp_Status: null,
          Freelance_OwnACompany: null,
          Industry_Sector: null,
          Other_Industry_Sector: null,
          Position: null,
          Other_Position: null,
          Employer: null,
          Biz_Nature: null,
          Other_Biz_Nature: null,
          Annual_Income: null,
          Annual_Income_Total:null, // 年收入
          Total_Saving_Investments: null,
          Saving_Investments_Money:null, //年存儲金額
          Funds_Source: null,
          Other_Funds_Source: null,
          Intend_Deposit: null,
          Afford_To_Lose:null, //是否承担损失
          Open_Trading_Account:null,
          // 第4页
          Futures_Options: null,
          CFDs_Spread_Bets: null,
          Derivative_Trade_over2: null,
          Derivative_Trade_over40: '',
          Average_Annual_Investment:null, //年平均投资
          Average_Leverage_Level:null, //平均杠杆
          // 第5页
          DT_Work_Experience: null,
          DT_Qualification: null,
          K_Sell_Position: null,
          Closing_Order: null,
          K_Profit_Change: null,
          K_Margin: null,
          // 第6页
          // Marketing_Email_Preference: null,
          Marketing_Email_Preference: true,
          Hear_ATFX: null,
          OtherHearATFX: null,
          Rec_Type: null,
          Parent_IB_Code: null,
          // 其他
          fileList:[],
          experience:null,
          qualification:null,
          checkList:[],
          Local_Ccy: "USD",
          Last_Update: null,
          Leverage: null,
          Rec_Type: null,
          Rec_Group: "A",
          IP_Addr: null,
          Browser: null,
          Curr_Status: null,
          Remark: null,
          Update_By: null,
          Process_By: null,
          Check_By: null,
          APT_Point: 0,
          NAT_ID: null,
          CXD_token:null,
          Ip_Country: null,
          Ip_City: null,
          Browser_Language: navigator.language || navigator.browserLanguage,
          referrerCode: '',
          referrerType: '',
          referrerGroup: ''
        },
        recodeModel:{
          personalDetails1:[],
          personalDetails2:[],
          financialDetails:[],
          Experience:[],
          Knowledge:[],
          Acknowledgements:[],
        },
        isDisable:false,
        Lead: {
          id: null,
          sf_campaignlead_id:null,
          data: {}
        },
        AA_Number: this.randomStr(),
        middle_dataware: {
          middle_lead_id: "",
          middle_campaignlead_id: "",
          middle_account_id: "",
          is_new_lead: 0
        },
        paddingTop: 0,
      };
    },
    beforeCreate(){
      _g.setCookie('isFitstLoad', 1);
    },
    created() {
      window.addEventListener('resize', this.getPaddingTop)
    },
    mounted(){
      this.getCountryByIP();  // 根据ip获取国家
      if(IsMaintain) {
        window.location.href="../../static/maintain.html";
      }
      if ('a' in this.$route.query) {      //MTAvQUEx-----10/AA1
        let char = new Buffer(this.$route.query.a, 'base64').toString();
        let charArr = char.split('/');
        this.formData.Parent_IB_Code = charArr[0];
        this.formData.Rec_Type = charArr[1];
        this.formData.Rec_Group = charArr[2];
        // this.setCookies('_lastpath',100,'.atfx.com');  // 保存cookies操作
      }
      this.setAffCookie();
      this.setUTMCookie();
      // if('s' in this.$route.query){
      //     this.isCompleted = !this.isCompleted;
      //     setTimeout(async ()=>{
      //       let _width = document.body.clientWidth;
      //       document.getElementById('external-frame').style = _width < 600 ? 'height: 67em !important' : 'height: 46em !important';
      //     },300)
      // }
      //QQ客服链接
      if(Cookies.get('language') === 'cn'){
        let qqmsg = document.getElementById('qqmsg');
        qqmsg.style.display = 'block';
      }
      this.init_url_params()
      this.getPaddingTop()
    },
    computed:{
      ...mapState(["LANGUAGE"]),
    },
    methods: {
      backCurrent(val, call) {
        this.current = call();
        this.components = this.getComponents(val);
      },
      getComponents(val) {
        return this.componentsArr[val];
      },
      next(val, call, funName) {

        if(val == 1){
          const arr = ["Addr","Addr2","Street","Building", "City","Province","Postcode"];
          arr.forEach(item=>{
            let name = (item == 'Building') ? '_Name' : '';
            let val = document.getElementById(item).value;
            this.formData[item+name] = val;
            document.getElementById(item).value = val;
          })
        }

        this.$refs["comp"].$children[0][funName](data => {
          if (data) {
          // if (true) {   // 打开下一页的所有权限
              console.log('val:'+ val);
            if (val < 5){
              this.current = call();
              this.components = this.getComponents(val + 1);
              _g.trackNextBottonEvent(this.current)
              window.scrollTo(0, 0)
            }else{
              this.submit();
            }
          }
        });
      },
      nextCurrent(val, call) {
        return this.next(val, call, "getPageFormData")
      },
      async submit() {
        this.isDisable = true;
        let model = {};
        let arr=['Email_Confirm','Birth_Date_Year','Birth_Date_Month','Birth_Date_Day','OtherTitle','OtherBank','Other_Industry_Sector','Other_Position','Other_Biz_Nature','Other_Funds_Source','OtherHearATFX','fileList','experience','qualification','checkList'];
        for (var key in this.formData) {
            if (arr.includes(key)) {
                continue;
            } else {
                model[key] = this.formData[key];
            }
        }
        let otherValObj = {
          Title:'OtherTitle',
          Bank:'OtherBank',
          Industry_Sector:'Other_Industry_Sector',
          Position:'Other_Position',
          Biz_Nature:'Other_Biz_Nature',
          Funds_Source:'Other_Funds_Source',
          Hear_ATFX: 'OtherHearATFX',
        }
        for(let key in otherValObj){
          model[key] = this.clearOtherVal(key,otherValObj[key])
        }
        model['occupation_position'] = ''
        if((model['Position'] >= 0 || model['Position']) && model['Position'] != null){
          let positionKey = model['Position'];
          model['occupation_position'] = this.formData['Position']=='7'?model['Position']: this.$t(`financialDetails.FD_Position_select.${positionKey}`);
        }
        model['Employment'] = ''
        if(model['Emp_Status'] >= 0 && model['Emp_Status'] != null){
          let Emp_StatusKey = '';
          switch (model['Emp_Status']) {
            case '0':
              Emp_StatusKey = 'Self-Employed'
              break;
            case '1':
              Emp_StatusKey = 'Employed';
              break;
            case '2':
              Emp_StatusKey = 'Student';
              break;
            case '3':
              Emp_StatusKey = 'Unemployed';
              break;
            case '4':
              Emp_StatusKey = 'Retired';
              break;
            default:
              Emp_StatusKey = 'Employed';
              break;
          }
          model['Employment'] = Emp_StatusKey;
        }
        model['Industry'] = ''
        if(model['Industry_Sector'] >= 0 && model['Industry_Sector'] != null){
          console.log('Industry_Sector===',this.formData['Industry_Sector']);
          let IndustryKey = model['Industry_Sector'];
          model['Industry'] = this.formData['Industry_Sector']=='16'?model['Industry_Sector']: this.$t(`financialDetails.Industry_Sector_select.${IndustryKey}`);
        }
        model['Annual_Income_Interval'] = ''
        if(model['Annual_Income'] >= 0 && model['Annual_Income'] != null){
          let Annual_IncomeKey = model['Annual_Income'];
          model['Annual_Income_Interval'] = this.$t(`financialDetails.annualIncomeSelect.${Annual_IncomeKey}`);
        }
        model['Total_Saving_Investments_Interval'] = ''
        if(model['Total_Saving_Investments'] >= 0 && model['Total_Saving_Investments'] != null){
          let Total_Saving_InvestmentsKey = model['Total_Saving_Investments'];
          model['Total_Saving_Investments_Interval'] = this.$t(`financialDetails.Total_Saving_Investments_select.${Total_Saving_InvestmentsKey}`);
        }
        model['Intend_to_Deposit'] = ''
        if(model['Intend_Deposit'] >= 0 && model['Intend_Deposit'] != null){
          let Intend_DepositKey = model['Intend_Deposit'];
          model['Intend_to_Deposit'] = this.$t(`financialDetails.intendDepositSelect.${Intend_DepositKey}`);
        }
        let uploadModel = ['Doc_Front_Img','Doc_Back_Img','Proof_of_Address','Proof_of_Address_2','Other_Files'];
        uploadModel.forEach(item=>{
          model[item] = (Boolean(this.formData[item][0]))?this.formData[item][0].url:null
        })
        model['Marketing_Email_Preference']=(this.formData['Marketing_Email_Preference'])?"Y":"N";

        if(!['USD','GBP','EUR'].includes(this.formData.MT4_Currency)) model.Rec_Type = null;
        else if(this.formData.Rec_Type == 'NAN') model.Rec_Type = 'A00';
        if ('a' in this.$route.query) {    
          model.Hear_ATFX = 'Partnership';
        }

        if (!this.formData.Annual_Income_Total || isNaN(this.formData.Annual_Income_Total) ){
          model.Annual_Income_Total = 0;
        }
        if (!this.formData.Annual_Income_Total || isNaN(this.formData.Saving_Investments_Money) ){
          model.Saving_Investments_Money = 0;
        }

        //ad
        model['CXD_token'] = Cookies.get("CXD_token") ? Cookies.get("CXD_token") : "";
        model['AFF_ID__c'] = Cookies.get("AFF_ID__c") ? Cookies.get("AFF_ID__c") : "";
        model['Utm_Campaign'] = Cookies.get("utm_campaign") ? Cookies.get("utm_campaign") : "";
        model['Utm_Content'] = Cookies.get("utm_content") ? Cookies.get("utm_content") : "";
        model['Utm_Medium'] = Cookies.get("utm_medium") ? Cookies.get("utm_medium") : "";
        model['Utm_Source'] = Cookies.get("utm_source") ? Cookies.get("utm_source") : "";
        model['Utm_Term'] = Cookies.get("utm_term") ? Cookies.get("utm_term") : "";
        model['Tel_Code'] = (model['curPhoneCode'] === "+1(USA)") ? "+1" : "+" + model['curPhoneCode'];
        // model['AA_Number'] = this.AA_Number || "";
        model['AA_Number'] = _g.getCookie('aanumber') || "";
        delete model['curPhoneCode'];
        var _this = this;
        _this.loading = true;
        await URL_REGISTER(model).then(res=>{
          if (res.status == 200) {
            if (res.data.code != 200) {
              _this.loading = false;
              let txt = '';
              if (res.data.msg == "Email&Doc_no No Match") {      //邮箱存在，但身份证不匹配
                  txt = this.$t('messages.emailAndDocInvalid');
              } else if (res.data.msg == "Phone&Doc_no No Match") {    //手机号存在，但身份证不匹配
                  txt = this.$t('messages.phoneAndDocInvalid');
              } else if (res.data.msg == 'Account was not found...') {     //Referrer Code不存在
                  txt = this.$t('messages.IBCodeInvalid');
              } else if (res.data.msg == 'age is err') {               //年龄不符合
                  txt = this.$t('errors.invalidBirthDate');
              } else if (res.data.msg == 'Bank_Card_No is error') {        //银行卡号有误
                  txt = this.$t('messages.invalidBankCardNo');
              }else{
                  txt =this.$t('messages.errors');
              }
              this.$alert(txt, this.$t('ModalMsg.showAlert.title'), {
                confirmButtonText: this.$t('ModalMsg.showModal.btn'),
                dangerouslyUseHTMLString: true,
              })
            } else {
              // this.isCompleted = !this.isCompleted;
              //更新salesforce步骤
               Util.editSalesforce(this.middle_dataware, 'Completed');
              //_this.loading = true;
              setTimeout(async ()=>{
                window.location.href="../../static/application-success.html?lang="+this.LANGUAGE;
                //_this.loading = false;
                // let _width = document.body.clientWidth;
                // document.getElementById('external-frame').style = _width < 600 ? 'height: 67em !important' : 'height: 46em !important';
              },1000)
            }
          }else{
            _this.loading = false;
            this.$alert(this.$t('messages.errors'), this.$t('ModalMsg.showAlert.title'), {
              confirmButtonText: this.$t('ModalMsg.showModal.btn'),
              dangerouslyUseHTMLString: true,
            })
          }
        }).catch((err)=>{
            console.log(err);
            _this.loading = false;
            _this.$alert('Please Try Again', this.$t('ModalMsg.showAlert.title'), {
            confirmButtonText: this.$t('ModalMsg.showModal.btn'),
            dangerouslyUseHTMLString: true,
          })
        })

        this.isDisable=false;
      },
      clearOtherVal(modelName,otherModelName){  //清空other值
        return (this.formData[otherModelName])?this.formData[otherModelName]:this.formData[modelName]
      },
      setCookies(name,years,domainVal) {
        let currLang = localStorage.langage;
        let cookiesVal = '';
        switch (currLang) {
          case "hk":
            cookiesVal = '/uk/zh-hant/'
            break;
          case 'cn':
            cookiesVal = '/uk/zh/';
            break;
          default:
            cookiesVal = `/uk/${currLang}/`;
            break;
        }
        var d = new Date;
        d.setTime(d.getTime() + 24*60*60*1000*365*years);
        window.document.cookie = name + "=" + cookiesVal + ";path=/;expires="+d.toGMTString()+";domain="+domainVal;
        window.document.cookie = name + "=" + cookiesVal + ";path=/;expires="+d.toGMTString();
      },
      setUTMCookie(){
        var utm_arr = ["utm_campaign","utm_content","utm_medium","utm_source","utm_term"]
        // var check_utm = false
        // for(var item of utm_arr){  //遍历UTM 如果存有任何一个就退出
        //   var utm_cookie = Cookies.get(item);
        //   if(utm_cookie) {
        //     check_utm = true
        //     break;
        //   }
        // }
        // if(check_utm) return  
        for(var item of utm_arr){
          if(!this.$route.query[item]) continue;
          Cookies.set(item, this.$route.query[item], { expires: 90, domain: ".atfx.com" });
          Cookies.set(item, this.$route.query[item], { expires: 90, domain: ".atfx-chinese.com" });
          Cookies.set(item, this.$route.query[item], { expires: 90, domain: ".atfx.com.cn" });
          Cookies.set(item, this.$route.query[item], { expires: 90, domain: ".chinese-atfx.com" });
        }
        return
      },
      setAffCookie(){
        // if(Cookies.get("AFF_ID__c") || Cookies.get("CXD_token")) return; //如果cookies中没有 AFF_ID__c & CXD_token 则根据Url中添加
        var arr = ['affid', 'CXD_token'];
        for(var item of arr){
          if(!this.$route.query[item]) return;
          Cookies.set(item == "affid"?"AFF_ID__c":item, this.$route.query[item], { expires: 90, domain: ".atfx.com" });
          Cookies.set(item == "affid"?"AFF_ID__c":item, this.$route.query[item], { expires: 90, domain: ".atfx-chinese.com" });
          Cookies.set(item == "affid"?"AFF_ID__c":item, this.$route.query[item], { expires: 90, domain: ".atfx.com.cn" });
          Cookies.set(item == "affid"?"AFF_ID__c":item, this.$route.query[item], { expires: 90, domain: ".chinese-atfx.com" });
        }
        return
      },
      getCountryByIP(){
        let ipUrl,countryCode;
        if('ip' in this.$route.query){
          if(!IsDev){
            ipUrl=`${GET_COUNTRY_CODE}/${this.$route.query.ip}/json`;
            countryCode = 'country';
          }else{
              ipUrl=ipUrl=`${GET_COUNTRY_CODE}/${this.$route.query.ip}`;
              countryCode = 'country';
          }
        }else{
            if(!IsDev){
                ipUrl=`${GET_COUNTRY_CODE}/json`;
                countryCode = 'country';
            }else{
                ipUrl=`${GET_COUNTRY_CODE}`;
                countryCode = 'country';
            }
        }
        URL_GETCOUNTRYCODE(ipUrl).then(res=>{
          if(res.status=='200'){
              let getCountryCode = res.data[countryCode];
              let getCountryList = this.$t("personalDetails1.countrySelect");
              this.formData.Country = getCountryCodeByIP(getCountryCode,getCountryList);
            }
        });
        URL_GETCOUNTRYCODE(IsDev ? GET_COUNTRY_CODE :GET_COUNTRY_CODE_PRD).then(res=>{
          if(res.status == 200) {
            this.formData.Ip_Country = res.data.country_name
            this.formData.Registered_IP = res.data.ip
            this.formData.Ip_City = res.data.city
            Cookies.set('GTM_COUNTRY', res.data.country_code_iso3);

            this.jumpToMUapply(this.formData.Ip_Country)
          }
        });
      },
      jumpToMUapply(country) { // 1628 根据ip对应国家跳转GM开户
        const countryArr = ["Brazil","Mexico","Colombia","Peru","Venezuela","Chile","Ecuador","Guatemala","Haiti","Bolivia","Dominican Republic","Honduras","Paraguay","Nicaragua","El Salvador","Costa Rica","Panama","Uruguay","Cuba","French Guiana","Guadeloupe","Guatemala","Martinique","Puerto Rico","Saint Barthélemy","Saint Martin","Saint Pierre and Miquelon"]
        if (countryArr.includes(country)) {
          const path = this.$route.path
          const fullPath = this.$route.fullPath
          const queryStr = fullPath.replace(path, "")
          window.location.href = MU_APPLY_URL + queryStr
        }
      },
      init_url_params() {
        this.pushReferrerData()
        let _query = this.$route.query;
        if (Object.keys(_query).length != 0 && Object.keys(_query).includes("a")) {
          try {
            let _a = atob(_query.a).split("/");   // 解码
            let code = _a[0];
            let type = _a[1];
            let group = _a[2];
            URL_CHECKBLACKIBCODE().then(res => {
              let blackList = res.data.data
              if(blackList.includes(code)) {
                this.formData.remark = 'ibIsBlack'
              }
            })
            URL_IBCODE({code: code }).then(res => {
              if (res.data.code === 200 && res.data.data != 'false') {
                this.set_referrer_cookie(code, type, group);
              } else {
                // if(!this.isSuccPage) this.$router.push('/')
              }
            })
            .catch(e => {
              console.error(e);
            })
          } catch (e) {
            this.set_referrer_cookie()
            console.error(e);
          }
        } else {
          let _temp_arr = Object.keys(Cookies.get());
          if (!(_temp_arr.includes("Referrer_Code") && _temp_arr.includes("Referrer_Type") && _temp_arr.includes("Referrer_Group"))) {
            this.set_referrer_cookie()
          }
        }
      },
      set_referrer_cookie(code="", type="", group="", parentCln="", ProId="") {
        let referrer = ['Referrer_Code','Referrer_Type','Referrer_Group','Referrer_Parent_Cln','Referrer_ProId'];
        let value = {
          Referrer_Code:code,
          Referrer_Type:type,
          Referrer_Group:group,
          Referrer_Parent_Cln:parentCln,
          Referrer_ProId:ProId,
        }
        for(var item of referrer){
          Cookies.set(item, value[item], { expires: 90, domain: ".atfx.com" });
          Cookies.set(item, value[item], { expires: 90, domain: ".atfx-chinese.com" });
          Cookies.set(item, value[item], { expires: 90, domain: ".atfx.com.cn" });
          Cookies.set(item, value[item], { expires: 90, domain: ".chinese-atfx.com" });
        }
        setTimeout(()=>{
          this.pushReferrerData()
        }, 500)
      },
      pushReferrerData() { // push到表单数据中
        this.formData.referrerCode = Cookies.get('Referrer_Code') || ''
        this.formData.referrerType = Cookies.get('Referrer_Type') || ''
        this.formData.referrerGroup = Cookies.get('Referrer_Group') || ''
      },
      randomStr(len = 16, encoding = 'hex') {
        return crypto.createHash('md5').update(Date.now().toString()).digest(encoding).substr(0, len);
      },
      getPaddingTop(){
        const hight = document.getElementById('sticky-risk').clientHeight
        this.paddingTop = hight + 'px'
      }
    },
    components: {
    }
  };

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import "../commons/sass/arcss.scss";
.register {
  padding-top:93px;
  .el-form-item.is-success .el-input__inner {
    border-color: #01284c
  }
  /*解决 iphone 点击两次选中 */
  .el-scrollbar {
    > .el-scrollbar__bar {
      opacity: 1 !important;
    }
  }

  .el-form-item.is-success .el-input__inner,
  .el-form-item.is-success .el-input__inner:focus {
    border-color: #01284c
  }

  .el-form-item.is-success .el-input__validateIcon {
    color: #01284c
  }
  .step-component{
    width:80%;
    margin:0 auto;
  }
  iframe{
    border-width: 0px
  }
}
.el-loading-parent--relative .el-loading-mask{
  position: fixed;
  background-color: rgba(255, 255, 255, 1); 
}
.el-loading-mask .my-loading{
  position: absolute;
  width: 800px;
  height: 570px;
  transform: translate(-50%,-50%);
  background: url(./../assets/images/loading.gif) no-repeat center center;
}
/*QQ客服链接*/
#qqmsg {
  display: none;
  position: fixed;
  bottom: 45%;
  margin-bottom: -75px;
  right: 0px;
  z-index: 100000;
  width: 40px;
  height: 150px;
  background-image: url(/static/images/qqmsg-2.png);
}
@media screen and (max-width:992px){
  .el-loading-mask .el-loading-spinner{
    height: 100%;
  }
  .el-loading-mask .my-loading{
    width: 100%;
    height: 100%;
    background-size: 100% auto;
  }
}

.radio-h5 {
  margin-left: 30px;
  display: inline-block;
}
.el-radio-group .radio-h5:first-child, .radio-h5:first-child {
  margin-left: 0;
}
@media (max-width: 768px){
  .radio-h5 {
    margin-left: 0px;
    margin-bottom: 16px;
    display: block;
  }
  .el-radio-group .radio-h5:last-child, .radio-h5:last-child {
    margin-bottom: 0;
  }
}
.radio-h5 .el-radio__label {
    display: inline-block;
    width: 100%;
    height: auto;
    white-space: normal;
    // font-family: Roboto;
    font-weight: 300;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.71;
    letter-spacing: 0.3px;
    color: #323232;
}
.el-form-item--small.el-form-item {
  margin-bottom: 24px;
}
.el-form--label-top .el-form-item__label {
  padding: 0 0 16px 0;
}

.el-input--small .el-input__inner {
    height: 43px !important;
    line-height: 43px !important;
}

</style>



// WEBPACK FOOTER //
// src/view/register.vue